import { IObraProyectoResponse } from '../models/interfaces';
import http from '../utils/http';

export const obrasProyectosService = async () => {
	const response = await http.get<IObraProyectoResponse[]>('ObrasProyectos');
	return response;
};
